export const formatDate = (dateString) => {
  if (!dateString) return '';

  const date = new Date(dateString);
  const options = { year: 'numeric', month: 'long', day: 'numeric' };
  return date.toLocaleDateString('en-US', options);
};

export const formatDateShort = (dateString) => {
  if (!dateString) return '';

  const date = new Date(dateString);
  const options = { month: 'short', day: 'numeric', year: '2-digit' };
  return date.toLocaleDateString('en-US', options);
};

export const monthYear = (dateString) => {
  if (!dateString) return '';

  const date = new Date(dateString);
  const options = { month: 'long', year: 'numeric' };
  return date.toLocaleDateString('en-US', options);
};
